import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";


const GroheFeatureNotInVisualizer = (props) => {
  const {intl, fabricatorData} = props;

  return (
    <div className="grohe-sold">
      {fabricatorData.isAmericanStandard ? null : (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                    className="look-icon look-icon--small look-icon--yellow">
          <ErrorIcon/>
        </IconButton>
      )}
      <span className="grohe-sold__text bold">
        <FormattedMessage id="grohe.feature.productNotVisualized" />
      </span>
    </div>
  )
};
const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData
  }
};

export default injectIntl(
  connect(mapStateToProps)(GroheFeatureNotInVisualizer)
)
